import { lazy, ComponentType, LazyExoticComponent } from 'react'
import { isTestEnv } from 'constants/Utils.constants'

export function loadComponentWithRetries(
  lazyComponent: () => Promise<{ default: ComponentType<any> }>,
  attemptsLeft: number,
  timeout: number // time in ms
): Promise<{ default: ComponentType<any> }> {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        if (attemptsLeft === 1) {
          reject(error)
          return
        }
        setTimeout(() => {
          loadComponentWithRetries(lazyComponent, attemptsLeft - 1, timeout).then(resolve, reject)
        }, timeout)
      })
  })
}

/** @deprecated */
export default function componentLoader<T>(
  lazyComponent: () => Promise<{ default: ComponentType<T> }>
): LazyExoticComponent<ComponentType<T>> {
  return lazy(() => loadComponentWithRetries(lazyComponent, 3, 1500))
}

export function conditionalLazy<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  if (isTestEnv) {
    const match = factory.toString().match(/(import|require)\(["'`](?<path>.*?)["'`]\)/)
    if (!match) throw new Error('Cannot resolve module path from factory')
    const path = match.groups!.path
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require(path).default as T
  }

  return lazy(factory)
}
